<p>
  <button app-add-button [label]="'events.settings.items.ceu-edit.add-ceu-label' | translate" (onClick)="handleAddClick()"> </button>
</p>

<table class="wl-credit-types-grid" [hidden]="!eventItemCreditTypes.length">
  <thead>
    <tr>
      <th></th>
      <th>
        {{ 'events.settings.items.ceu-edit.credit-type-column-header' | translate | titlecase }}
      </th>
      <th>
        {{ 'events.settings.items.ceu-edit.ceu-credits-column-header' | translate | titlecase }}
      </th>
    </tr>
  </thead>
  <tbody>
    <tr
      *ngFor="let eventItemCreditType of eventItemCreditTypes"
      [ngClass]="{ 'wl-pending-delete': eventItemCreditType.ObjectState == _objectStateEnum.Deleted }"
    >
      <td>
        <button
          pButton
          class="btn btn-danger btn-sm"
          type="button"
          (click)="handleRemoveClick(eventItemCreditType)"
          [hidden]="eventItemCreditType.ObjectState == _objectStateEnum.Deleted"
          icon="pi pi-trash"
        ></button>

        <button
          pButton
          class="btn btn-default btn-sm"
          type="button"
          (click)="handleUnRemoveClick(eventItemCreditType)"
          [hidden]="eventItemCreditType.ObjectState != _objectStateEnum.Deleted"
          [title]="'common.undelete' | translate | titlecase"
          icon="pi pi-refresh"
        ></button>
      </td>
      <td>
        <wl-events-ceu-type-dropdown
          [(ngModel)]="eventItemCreditType.CreditTypeId"
          inputCssClass="form-control wl-credit-type-input"
          [required]="true"
          (onCreditTypeChange)="handleCreditTypeChange(eventItemCreditType, $event)"
          [disabled]="eventItemCreditType.ObjectState == _objectStateEnum.Deleted"
        ></wl-events-ceu-type-dropdown>
      </td>
      <td>
        <input
          [(ngModel)]="eventItemCreditType.Credits"
          class="form-control wl-credits-input"
          type="number"
          min="0"
          [disabled]="eventItemCreditType.ObjectState == _objectStateEnum.Deleted"
        />
      </td>
    </tr>
  </tbody>
</table>
